import { render, staticRenderFns } from "./base-order-details.component.vue?vue&type=template&id=7332a288&scoped=true&"
import script from "./base-order-details.component.ts?vue&type=script&lang=ts&"
export * from "./base-order-details.component.ts?vue&type=script&lang=ts&"
import style0 from "./base-order-details.component.scss?vue&type=style&index=0&id=7332a288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7332a288",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
